import React from 'react';
import ReactDOM from 'react-dom';
import { withTranslation } from 'react-i18next';
import sanitizeHtml from 'sanitize-html';
import { allowFileUpload } from '../../utils/common';

import ImgIconComp from '../imgcomp';
import { nowToUnix } from '../../apps/meetings/utils/dates';
import { v4 as uuidv4 } from 'uuid';

import { generateSASAnduploadToTempLocation, WoboFileUploadService } from '../../../src/services/fileupload.service';

import GoalServices from "../../../src/services/goal.services";

const services = new GoalServices();

class FileUploadComp extends React.Component {
  constructor(props) {
    super(props);
    this.showOtherSource = this.showOtherSource.bind(this);
    this.hideOtherSource = this.hideOtherSource.bind(this);
    this.closeAddLinkPopup = this.closeAddLinkPopup.bind(this);
    this.showLinkAttachMentChangePopup = this.showLinkAttachMentChangePopup.bind(this);
    this.loadLinkPopup = this.loadLinkPopup.bind(this);
    this.saveLink = this.saveLink.bind(this);
    this.saveLinksToAttachment = this.saveLinksToAttachment.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.updateAgenda = this.updateAgenda.bind(this);
    this.loadPopup = this.loadPopup.bind(this);
    this.showFilenameChangePopup = this.showFilenameChangePopup.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.setFileUpload = this.setFileUpload.bind(this);
    this.errorFileUploading = this.errorFileUploading.bind(this);
    this.aiEditLoadBoxFile = this.aiEditLoadBoxFile.bind(this);
    this.aiEditLoadDropBoxFile = this.aiEditLoadDropBoxFile.bind(this);
    this.loadOneDriveFile = this.loadOneDriveFile.bind(this);
    this.oneDriveTimeoutId = null;
  }

  componentDidMount() {
    const _this = this;
    const { showFilenamePopup } = this.props;
    if (showFilenamePopup == '1') {
      _this.showPopupElement = document.getElementById('change-filename-popup');
      $(_this.showPopupElement).dialog({
        autoOpen: false,
        resizable: false,
        minHeight: 240,
        minWidth: 500,
        modal: true,
        open(event, ui) {
          $(_this.showPopupElement).siblings('div.ui-dialog-titlebar').remove();
          $(_this.showPopupElement).parents('div.ui-dialog').css('padding', '0');
          $(_this.showPopupElement).css({ 'min-height': '135px' });
          $(_this.showPopupElement).parent().addClass('dialogbox-shadow');
        },
      });
    }
  }

  componentWillUnmount() {
    // Clean up any pending timeout to prevent memory leaks and React warnings
    if (this.oneDriveTimeoutId !== null) {
      clearTimeout(this.oneDriveTimeoutId);
      this.oneDriveTimeoutId = null;
    }
  }

  showOtherSource() {
    this.setState({
      enOtherSource: true,
    });
  }

  hideOtherSource() {
    this.setState({
      enOtherSource: false,
    });
  }

  closeAddLinkPopup(e) {
    if (e) {
      e.preventDefault();
    }
    $(this.showPopupElement).dialog('close');
  }

  showLinkAttachMentChangePopup(e) {
    if (this.showPopupElement) {
      ReactDOM.unmountComponentAtNode(this.showPopupElement);
    }
    ReactDOM.render(this.loadLinkPopup(), this.showPopupElement);
    $(this.showPopupElement).dialog('open');
  }

  loadLinkPopup() {
    const { t } = this.props;
    return (
      <div className="wbmodal wbmodal-filename-change">
        <div className="wbmodal-header">
          <div className="wbmodal-htitle left">
            <b>{t('Add a link')}</b>
          </div>
          <div className="wbmodal-hcancel right clickable" onClick={e => this.closeAddLinkPopup(e)}>
            <ImgIconComp id="close" width="13" height="13" />
          </div>
          <div className="clear" />
        </div>
        <div className="wbmodal-content">
          <div className="addwoboitem-text-wrapper">
            <div className="errormsg" />
          </div>
          <div className="displayTable actionTable bottomBorder" style={{ width: '100%', paddingBottom: '15px' }}>
            <div className="displayRow">
              <div className="displayCell customLinkDiv">
                <input type="text" name="link" placeholder={t('Paste link here')} className="gbl-text-entry form-control customLink" id="link" style={{ width: '96%', padding: '10px' }} />
                <p className="linkPopUpErrorMsg">{t('The link you entered is invalid, please enter a valid link including http:// or https://')}</p>
              </div>
            </div>
          </div>
          <div className="gbl-btn" style={{ marginLeft: '80%' }} onClick={e => this.saveLink(e)}>{t('Save Link')}</div>
        </div>
      </div>
    );
  }

  saveLink() {
    const linkText = $('#link').val();
    const {
      saveData,
    } = this.props;
    if (typeof linkText !== 'undefined' && $.trim(linkText).length == 0) {
      $('.linkPopUpErrorMsg').show();
      return;
    } if ($.trim(linkText).toLowerCase().indexOf('http') == -1 && $.trim(linkText).toLowerCase().indexOf('https') == -1 && $.trim(linkText).toLowerCase().indexOf('ftp') == -1) {
      $('.linkPopUpErrorMsg').show();
      return;
    }

    if (linkText) {
      let params = {
        path: linkText, link_name: linkText, link_type: 7, object_type: 'attachment_link',
      };
      params = Object.assign({}, params, saveData);
      this.saveLinksToAttachment(params);
    } else {
      $(this.showPopupElement).dialog('close');
    }
  }

  saveLinksToAttachment(params) {
    $.ajax({
      url: `${wbConfig.baseUrl}/` + 'meeting/saveMeetingAttachmentLink',
      type: 'POST',
      data: params,
      dataType: 'json',
      async: true,
    })
      .done((response) => {
        if (typeof response.error !== 'undefined') {
          window.history.pushState({showError: response.error}, '', window.location.href);
          return;
        }

        this.props.refreshLegacyData(response.data);
      });
    $(this.showPopupElement).dialog('close');
  }

  closePopup(e, attachment) {
    if (e) {
      e.preventDefault();
    }
    const { events } = this.props;
    this.setFileUpload();
    $(this.showPopupElement).dialog('close');
    if (typeof events.MeetingAddTopicItems !== 'undefined') {
      setTimeout(() => {
        events.MeetingAddTopicItems(attachment, true);
      }, 10);
    }
  }

  updateAgenda(e, attachment) {
    const { currentUser } = this.props;
    e.preventDefault();

    const updateAgenda = document.getElementById('update_agenda');
    const updateAgendaValue = updateAgenda.value.trim();
    if (updateAgendaValue) {
      attachment.description = updateAgendaValue;
      $.post(`${wbConfig.baseUrl}/meeting/updateFilenameAgenda`, attachment);
      this.closePopup(e, attachment);
    } else {
      this.closePopup(e, attachment);
    }
    create_topic('meet', {
      action: 'add',
      data: [attachment],
      type: 'wobo_object',
      firstname: currentUser.firstname,
      lastname: currentUser.lastname,
    });
  }

  loadPopup(attachment) {
    const { t } = this.props;
    attachment.description = sanitizeHtml(attachment.description, {
      allowedTags: [],
      disallowedTagsMode: 'discard'
    })
    return (
      <div className="wbmodal wbmodal-filename-change">
        <div className="wbmodal-header">
          <div className="wbmodal-htitle left">
            <b>{t('Add comments or context with this file')}</b>
          </div>
          <div className="wbmodal-hcancel right clickable" onClick={e => this.closePopup(e, attachment)}>
            <ImgIconComp id="close" width="13" height="13" />
          </div>
          <div className="clear" />
        </div>
        <div className="wbmodal-content">
          <div className="addwoboitem-text-wrapper">
            <div className="errormsg" />
          </div>
          <div className="addwoboitem-wrapper" data-testid="addwoboitem-wrapper" style={{ height: 'auto' }}>
            <div className="width100"><b>{t('File Name')}</b></div>
            <div className="width100">
              <div className="filenametext">
                {attachment.description}
              </div>
              <div className="filenamecomment">
                <textarea name="update_agenda" id="update_agenda" placeholder={t('Add a comment(optional)')} />
              </div>
            </div>
          </div>
          <div className="gbl-btn" style={{ marginLeft: '70%' }} onClick={e => this.updateAgenda(e, attachment)}>{t('Update agenda')}</div>
        </div>
      </div>
    );
  }

  showFilenameChangePopup(attachment) {
    if (this.showPopupElement) {
      ReactDOM.unmountComponentAtNode(this.showPopupElement);
    }
    ReactDOM.render(this.loadPopup(attachment), this.showPopupElement);
    $(this.showPopupElement).dialog('open');
  }

  handleFileUpload() {
    this.uploadFileField.click();
    this.props.parent.setState({ isUpload: false });
  }

  // TODO!: below needs to get moved to a service layer 
  handleFileChange(e) {
    const { t } = this.props;
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    const {
      url, saveData, events, showFilenamePopup, isFUSEnabled, userId, orgId, appinID, accessToken , currentUser
    } = this.props;
    const _this = this;
    if (url != 'undefined' && saveData !== 'undefined') {
      const file = this.uploadFileField.files[0];
      if (typeof file === 'undefined') {
        return;
      }
      if (file.size > upload_max_size) {
        alert(t('The file you have uploaded exceeds the maximum size of {upload_max_size_configured}MB.', { upload_max_size_configured: upload_max_size }));
        return;
      }
      const extension = file.name.split('.').pop();
      if ( !allowFileUpload('meetings', extension) ) {
        alert(t('The file type you have uploaded is not supported.'));
        return;
      }

      const createTopicFromAttachment = function(data) {
        if (typeof events.MeetingAddTopicItems !== 'undefined') {
          if (showFilenamePopup == '1') {
            _this.showFilenameChangePopup(data);
          } else {
            _this.setFileUpload();
            events.MeetingAddTopicItems(data, true);
            this.props.refreshLegacyData();
            create_topic('meet', {
              action: 'add',
              data: [data],
              firstname: currentUser.firstname,
              lastname: currentUser.lastname,
              type: 'wobo_object'
            });
          }
        }
      }

      const updateFile = (signature, delayMs) => {
        const _this = this;
        const clearTimer = setInterval(async () => {
          services
            .getFileStatus({ signature })
            .then((response) => {
              const jsonData = response?.data
              if (jsonData) {
                if (
                  jsonData?.resp?.fus_type == 1 &&
                  jsonData?.resp?.fus_status == 1 &&
                  jsonData?.resp?.path
                ) {
                  clearInterval(clearTimer)
                  _this.props.refreshLegacyData();
                }
              }
            })
            .catch((err) => {})
        }, delayMs)
      }

      const callUpload = function() {
        showLoaderWidget($('#content'));
        // If FUS enabled then allow the user to upload the file using FUS
        if (isFUSEnabled) {
          let request_id = uuidv4();
          generateSASAnduploadToTempLocation(file, {
            appinID,
            request_id,
            accessToken,
            userId,
            orgId,
          }).then((newFilename) => {
            if (newFilename) {
              const fileName = createFilename(file.name)
              const fileSize = file.size;
              const prefix = newFilename
              const params = {
                fileName,
                prefix,
                link_type: 1,
                s3DirectUpload: 2,
                fus_type: 1,
                fus_status: 2,
                meeting_id:saveData.meeting_id,
                fileSize
              }
              $.ajax({
                url: `${wbConfig.baseUrl}/${url}`,
                type: 'POST',
                data: params,
                dataType: 'json',
                async: true,
              })
                .done((response) => {
                  let request_id = uuidv4();
                  let targetFolderName = uuidv4();
                  // Polling to get the data and update the attachment details
                  const fileObj = {
                    source_fileName: newFilename,
                    file_mimetype: file.type,
                    file_size: file.size,
                    request_id: request_id,
                    signature: prefix,
                    appInID: "woboclient", // Client app id and the same name for client container in the azure
                    byok_tenant_id: "", // this is the tenant id for encrypting the file with
                    file_originalname: fileName, // Name of the file
                    webhook_details: {
                      "host": `${wbConfig.baseDomainUrl}/fus/fusCallback?type=1`,
                      "path": "",
                    },
                    orgId: currentUser.org_id, // Organization id
                    userId: currentUser.id, // User id of the requested user
                    target_folder: targetFolderName, // Name of the target folder inside the target container,
                  }
                  createTopicFromAttachment(response.attachment);
                  let ListOfFile = response.attachment;
                  WoboFileUploadService.processFile(fileObj).then(() => {
                    updateFile(prefix, 15000);
                  }).catch((err) => {
                    _this.props.deleteTopicTakeNonTake(ListOfFile.id, saveData.meeting_id, 'topic', ListOfFile)
                    $(_this.showPopupElement).dialog('close');
                  })
                  removeLoaderWidget();
                })
                .fail(() => {
                  console.error(t('Something went wrong, please try again later.'));
                })
            }
          })
        } else {
          $.ajax({
            url: `${wbConfig.baseUrl}/workboard/GetS3Data`,
            type: 'GET',
            dataType: 'json',
          })
          .done((resp) => {
            const fileName = createFilename(file.name);
            const fileSize = file.size;
            const { prefix } = resp;

            // upload file to Azure file storage
            if (typeof resp.encrypt_type !== 'undefined' && resp.encrypt_type === 'azure:sse') {
              uploadFileToAzureStorage(resp.asc, `${prefix}/original/${fileName}`, file)
              .then(result => {
                const params = {
                  meeting_id: saveData.meeting_id,
                  s3DirectUpload: 2,
                  prefix,
                  fileName,
                  fileSize
                };
                $.ajax({
                  url: `${wbConfig.baseUrl}/${url}`,
                  type: 'POST',
                  data: params,
                  dataType: 'json',
                  async: true,
                })
                .done((response) => {
                  removeLoaderWidget();
                  createTopicFromAttachment(response.attachment);
                  this.props.refreshLegacyData();
                })
                .fail(() => {
                  _this.errorFileUploading;
                });
              })
              .catch(error => {
                console.error(error);
                _this.errorFileUploading;
              });

            // upload file to AWS S3
            } else {
              uploadSignedFileToS3Storage({file, resp})
              .then(result => {
                const params = {
                  meeting_id: saveData.meeting_id,
                  s3DirectUpload: 1,
                  prefix,
                  fileName,
                  fileSize,
                  pos: nowToUnix()
                };
                $.ajax({
                  url: `${wbConfig.baseUrl}/${url}`,
                  type: 'POST',
                  data: params,
                  dataType: 'json',
                  async: true,
                })
                .done((response) => {
                  removeLoaderWidget();
                  createTopicFromAttachment(response.attachment);
                })
                .fail(() => {
                  _this.errorFileUploading;
                });
              })
              .catch(error => {
                console.error(error);
                _this.errorFileUploading;
              });
            }
            // end of upload files
          })
          .fail(() => {
            _this.errorFileUploading;
          });
        }
      };

      if (window.FileReader && window.Blob) {
        const filereader = new FileReader();
        filereader.onloadend = function (evt) {
          if (evt.target.readyState === FileReader.DONE) {
            const uint = new Uint8Array(evt.target.result);
            const bytes = [];
            $.each(uint, (i, byte) => {
              bytes.push(byte.toString(16));
            });
            const hex = bytes.join('').toUpperCase();
            if (hex == '4D5A900' || hex == '4D5A5000' || hex == 'FE49BCB') {
              alert(t('The file type you have uploaded is not supported.'));
              return;
            }
            callUpload();
          }
          $('#attach')[0].value = '';
        };
        const blob = file.slice(0, 4);
        filereader.readAsArrayBuffer(blob);
      } else {
        callUpload();
      }
    }
  }

  setFileUpload() {
    const { parent } = this.props;
    if (parent) {
      parent.setState({ isUpload: false });
    }
  }

  errorFileUploading() {
    const { t } = this.props;
    this.setFileUpload();
    removeLoader();
    alert(t('Error while upload. please try again'));
  }

  aiEditLoadBoxFile(boxApiKey) {
    const {
      saveData, events, currentUser,
    } = this.props;
    const oo = { clientId: boxApiKey, linkType: 'shared', multiselect: 'true' };
    const boxSelect = new BoxSelect(oo);

    // Register a success callback handler
    boxSelect.success((response) => {
      const links = [];

      // Parse file names and shared links from response. Store data into arrays.
      for (let i = 0; i < Object.keys(response).length; i++) {
        const obj = response[i];
        links.push({ name: obj.name, link: obj.url });
      }
      const att_type = 6; // drop box link type
      Object.keys(links).map((objectKey, index) => {
        const value = links[objectKey];
        let params = {
          path: value.link, link_name: value.name, link_type: att_type, object_type: 'attachment_link',
        };
        params = Object.assign({}, params, saveData);
        $.ajax({
          url: `${wbConfig.baseUrl}/meeting/saveMeetingAttachmentLink`,
          type: 'POST',
          data: params,
          dataType: 'json',
          async: true,
        })
          .done((response) => {
            if (typeof response.error !== 'undefined') {
              window.history.pushState({showError: response.error}, '', window.location.href);
              return;
            }
            this.props.refreshLegacyData(response.data);
          });
      });

      boxSelect.closePopup();
    });

    boxSelect.cancel(() => {
    });
    boxSelect.launchPopup();
  }

  aiEditLoadDropBoxFile(dropBoxApiKey) {
    const {
      saveData, events, currentUser,
    } = this.props;
    const options = {
      success(files) {
        const att_type = 3;
        const links = files;
        Object.keys(links).map((objectKey, index) => {
          const value = links[objectKey];
          let params = {
            path: value.link, link_name: value.name, link_type: att_type, object_type: 'attachment_link',
          };
          params = Object.assign({}, params, saveData);
          $.ajax({
            url: `${wbConfig.baseUrl}/` + 'meeting/saveMeetingAttachmentLink',
            type: 'POST',
            data: params,
            dataType: 'json',
            async: true,
          })
            .done((response) => {
              if (typeof response.error !== 'undefined') {
                window.history.pushState({showError: response.error}, '', window.location.href);
                return;
              }
              this.props.refreshLegacyData(response.data);
            });
        });
      },
      cancel() {

      },
      linkType: 'preview',
      multiselect: true,
    };
    Dropbox.appKey = dropBoxApiKey;
    Dropbox.choose(options);
  }

  loadOneDriveFile() {
    const {
      saveData, msAppId, meetingRedirectUrl, t,
    } = this.props;
    
    // Check if OneDrive library is loaded
    if (typeof window.OneDrive === 'undefined') {
      if (typeof window.initOneDrive === 'function') {
        window.initOneDrive();
        // Clear any existing timeout before setting a new one
        if (this.oneDriveTimeoutId !== null) {
          clearTimeout(this.oneDriveTimeoutId);
          this.oneDriveTimeoutId = null;
        }
        // Wait a bit for the script to load, then try again
        this.oneDriveTimeoutId = setTimeout(() => {
          this.oneDriveTimeoutId = null;
          if (typeof window.OneDrive !== 'undefined') {
            this.loadOneDriveFile();
          } else {
            // OneDrive still not loaded after timeout - inform user
            console.error('[OneDrive Error]', 'OneDrive library failed to load after initialization attempt', {
              initOneDriveExists: typeof window.initOneDrive === 'function',
              oneDriveExists: typeof window.OneDrive !== 'undefined',
            });
            if (t) {
              alert(t('OneDrive failed to load. Please refresh the page and try again.'));
            } else {
              alert('OneDrive failed to load. Please refresh the page and try again.');
            }
          }
        }, 500);
      } else {
        // initOneDrive function doesn't exist - inform user
        console.error('[OneDrive Error]', 'OneDrive initialization function not found', {
          initOneDriveExists: typeof window.initOneDrive === 'function',
          oneDriveExists: typeof window.OneDrive !== 'undefined',
        });
        if (t) {
          alert(t('OneDrive is not available. Please ensure OneDrive integration is properly configured.'));
        } else {
          alert('OneDrive is not available. Please ensure OneDrive integration is properly configured.');
        }
      }
      return;
    }
    
    const finalMsAppId = msAppId || window.msAppId;
    const finalRedirectUrl = meetingRedirectUrl || window.meetingRedirectUrl;
    
    if (!finalMsAppId || !finalRedirectUrl) {
      const errorMessage = !finalMsAppId 
        ? 'OneDrive integration is not configured. Microsoft App ID is missing.'
        : 'OneDrive integration is not configured. Redirect URL is missing.';
      console.error('[OneDrive Error]', errorMessage, {
        msAppId: finalMsAppId ? 'present' : 'missing',
        meetingRedirectUrl: finalRedirectUrl ? 'present' : 'missing',
        propsMsAppId: msAppId,
        propsMeetingRedirectUrl: meetingRedirectUrl,
        windowMsAppId: window.msAppId,
        windowMeetingRedirectUrl: window.meetingRedirectUrl,
      });
      if (t) {
        alert(t('OneDrive integration is not properly configured. Please contact your administrator.'));
      } else {
        alert('OneDrive integration is not properly configured. Please contact your administrator.');
      }
      return;
    }
    
    const self = this;
    const odOptions = {
      clientId: finalMsAppId,
      action: 'share',
      multiSelect: true,
      advanced: {
        redirectUri: finalRedirectUrl,
        createLinkParameters: { type: 'view', scope: 'organization' },
        scopes: ["Files.ReadWrite", "Sites.Read.All", "User.Read"]
      },
      success(files) {
        const docs = files.value;
        const att_type = 7;
        const links = [];
        for (let i = 0; i < docs.length; i++) {
          if (docs[i].permissions.length > 0) {
            links.push({
              link_name: docs[i].name,
              path: docs[i].permissions[0].link.webUrl,
              object_type: 'attachment_link',
              link_type: att_type,
            });
          } else {
            links.push({
              link_name: docs[i].name,
              path: docs[i].webUrl,
              object_type: 'attachment_link',
              link_type: att_type,
            });
          }
        }
        for (let l = 0; l < links.length; l++) {
          const params = Object.assign({}, links[l], saveData);
          $.ajax({
            type: 'POST',
            url: `${wbConfig.baseUrl}/` + 'meeting/saveMeetingAttachmentLink',
            data: params,
            dataType: 'json',
            async: true,
          })
            .done((response) => {
              if (typeof response.error !== 'undefined') {
                window.history.pushState({showError: response.error}, '', window.location.href);
                return;
              }
              self.props.refreshLegacyData(response.data);
            });
        }
      },
      cancel() { 
        // cancel handler
      },
      error(e) {
        // Error handler for OneDrive integration failures
        console.error('[OneDrive Error]', 'OneDrive picker error:', e, {
          errorType: e?.type || 'unknown',
          errorMessage: e?.message || 'Unknown error',
          msAppId: finalMsAppId ? 'present' : 'missing',
          meetingRedirectUrl: finalRedirectUrl ? 'present' : 'missing',
        });
        if (t) {
          alert(t('Failed to load OneDrive files. Please try again or contact your administrator if the problem persists.'));
        } else {
          alert('Failed to load OneDrive files. Please try again or contact your administrator if the problem persists.');
        }
      },
    };
    
    try {
      OneDrive.open(odOptions);
    } catch (error) {
      // Error handling for OneDrive.open() exceptions
      console.error('[OneDrive Error]', 'Failed to open OneDrive picker:', error, {
        errorName: error?.name || 'Unknown',
        errorMessage: error?.message || 'Unknown error',
        stack: error?.stack,
        msAppId: finalMsAppId ? 'present' : 'missing',
        meetingRedirectUrl: finalRedirectUrl ? 'present' : 'missing',
        oneDriveAvailable: typeof window.OneDrive !== 'undefined',
      });
      if (t) {
        alert(t('Failed to open OneDrive. Please ensure OneDrive is properly configured and try again.'));
      } else {
        alert('Failed to open OneDrive. Please ensure OneDrive is properly configured and try again.');
      }
    }
  }

  render () {
    const { t } = this.props;
    return (
      <div
        className="meetingAttachMenuWrap wbActPopup"
        style={{
          width: 'max-content',
          zIndex: '1004',
          whiteSpace: 'nowrap',
          display: (this.props.hoverOtherSourceEn) ? 'block' : 'none'
        }}>
        {
          !window.wbConfig.isMeetingsFileUploadHidden && (
            <div className="attachMenuItem clickable" onClick={() => this.handleFileUpload()}>
              <input type="file" id="attach" name="attach" ref={(input) => { this.uploadFileField = input; }} onChange={e => this.handleFileChange(e)} style={{ display: 'none' }} />
              <div className="aiEditAttachMenuImg uploadFromComp aiEditAttachMenuUploadCompImg vAlignM" />
              <div className="displayInlineBlock">
                <ImgIconComp className="meetingAttachOtherSource" id="linkToYourComputer" width="20" height="19" style={{ float: 'left', marginTop: '5px', paddingRight: '8px' }} />
                <span id="uploadFromComp" className="clickable uploadFromComp">{t('Your Computer')}</span>
              </div>
            </div>
          )
        }
        <div 
          className="attachMenuItem clickable" 
          style={{ display: (!this.props.fromWhere) ? 'block' : 'none' }} 
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            try {
              this.loadOneDriveFile();
            } catch (error) {
              // Error handling for unexpected failures in loadOneDriveFile()
              console.error('[OneDrive Error]', 'Unexpected error in loadOneDriveFile():', error, {
                errorName: error?.name || 'Unknown',
                errorMessage: error?.message || 'Unknown error',
                stack: error?.stack,
                props: {
                  msAppId: this.props.msAppId ? 'present' : 'missing',
                  meetingRedirectUrl: this.props.meetingRedirectUrl ? 'present' : 'missing',
                },
              });
              const { t } = this.props;
              if (t) {
                alert(t('An unexpected error occurred while loading OneDrive. Please try again or contact support.'));
              } else {
                alert('An unexpected error occurred while loading OneDrive. Please try again or contact support.');
              }
            }
          }}
        >
          <div className="aiEditAttachMenuImg aiEditAttachMenuLinkImg vAlignM" />
          <div className="displayInlineBlock">
            {t('Link to OneDrive')}
            {' '}
            <ImgIconComp className="meetingAttachOtherSource" id="linkToOneDrive" width="20" height="19" style={{ float: 'left', marginTop: '5px', paddingRight: '8px' }} />
          </div>
        </div>
        <div className="attachMenuItem clickable" style={{ display: (!this.props.fromWhere) ? 'block' : 'none' }} onClick={() => this.aiEditLoadBoxFile(this.props.boxApiKey)}>
          <div className="aiEditAttachMenuImg aiEditAttachMenuLinkImg vAlignM" />
          <div className="displayInlineBlock">
            {t('Link to Box')}
            {' '}
            <ImgIconComp className="meetingAttachOtherSource" id="linkToBox" width="20" height="20" style={{ float: 'left', marginTop: '5px', paddingRight: '8px' }} />
          </div>
        </div>
        <div className="attachMenuItem clickable" style={{ display: (!this.props.fromWhere) ? 'block' : 'none' }} onClick={() => this.aiEditLoadDropBoxFile(this.props.dropBoxApiKey)}>
          <div className="aiEditAttachMenuImg aiEditAttachMenuLinkImg vAlignM" />
          <div className="displayInlineBlock">
            {t('Link to Dropbox')}
            {' '}
            <ImgIconComp className="meetingAttachOtherSource" id="linkToDropBox" width="20" height="19" style={{ float: 'left', marginTop: '5px', paddingRight: '8px' }} />
          </div>
        </div>
        <div className="attachMenuItem clickable " onClick={e => this.showLinkAttachMentChangePopup(e)}>
          <div className="aiEditAttachMenuImg  vAlignM" />
          <div className="displayInlineBlock">
            {t('Add a Link')}
            {' '}
            <ImgIconComp className="meetingAttachOtherSource" id="linkToLink" width="20" height="19" style={{ float: 'left', marginTop: '5px', paddingRight: '8px' }} />
          </div>
        </div>
      </div>

    );
  }
}
export default withTranslation()(FileUploadComp);
